var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavourites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8498 2.50114C16.4808 2.50114 17.1108 2.59014 17.7098 2.79114C21.4008 3.99114 22.7308 8.04114 21.6198 11.5811C20.9898 13.3901 19.9598 15.0411 18.6108 16.3901C16.6798 18.2601 14.5608 19.9201 12.2798 21.3501L12.0298 21.5011L11.7698 21.3401C9.48077 19.9201 7.34977 18.2601 5.40077 16.3801C4.06077 15.0311 3.02977 13.3901 2.38977 11.5811C1.25977 8.04114 2.58977 3.99114 6.32077 2.77014C6.61077 2.67014 6.90977 2.60014 7.20977 2.56114H7.32977C7.61077 2.52014 7.88977 2.50114 8.16977 2.50114H8.27977C8.90977 2.52014 9.51977 2.63014 10.1108 2.83114H10.1698C10.2098 2.85014 10.2398 2.87114 10.2598 2.89014C10.4808 2.96114 10.6898 3.04114 10.8898 3.15114L11.2698 3.32114C11.3616 3.37011 11.4647 3.44494 11.5537 3.50961C11.6102 3.55058 11.661 3.58748 11.6998 3.61114C11.7161 3.62076 11.7327 3.63044 11.7494 3.6402C11.8351 3.69026 11.9245 3.7424 11.9998 3.80014C13.1108 2.95114 14.4598 2.49114 15.8498 2.50114ZM18.5098 9.70114C18.9198 9.69014 19.2698 9.36114 19.2998 8.94014V8.82114C19.3298 7.42014 18.4808 6.15114 17.1898 5.66114C16.7798 5.52014 16.3298 5.74114 16.1798 6.16114C16.0398 6.58114 16.2598 7.04114 16.6798 7.19014C17.3208 7.43014 17.7498 8.06114 17.7498 8.76014V8.79114C17.7308 9.02014 17.7998 9.24114 17.9398 9.41114C18.0798 9.58114 18.2898 9.68014 18.5098 9.70114Z",
    fill: "#292929",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourites);
export default __webpack_public_path__ + "static/media/favourites.952a0a1673f8260ebef9ccb16c1f442e.svg";
export { ForwardRef as ReactComponent };